export const changeZoomReducer = (state = null, action) => {
  switch (action.type) {
    case "CHANGE_ZOOM":
      return action.payload.zoom;
    default:
      return state;
  }
};
